import { createActionsHook, createContainer, createStateHook, createStore } from 'react-sweet-state';
export const setIsTemplateLibraryOpen = isOpen => ({
  setState
}) => {
  setState({
    isTemplateLibraryOpen: isOpen
  });
};
export const setSelectedTemplate = selectedTemplate => ({
  setState
}) => {
  setState({
    selectedTemplate
  });
};
export const setTemplates = (id, template) => ({
  setState,
  getState
}) => {
  const currentTemplates = getState().templates;
  if (!currentTemplates[id]) {
    currentTemplates[id] = {
      ...template
    };
    setState({
      templates: {
        ...currentTemplates
      }
    });
  }
};
const actions = {
  setIsTemplateLibraryOpen,
  setSelectedTemplate,
  setTemplates
};
const Store = createStore({
  initialState: {
    isTemplateLibraryOpen: false,
    selectedTemplate: undefined,
    templates: {}
  },
  name: 'proforma-template-library-store',
  actions
});
export const TemplateLibraryContainer = createContainer(Store);
export const useTemplateLibraryState = createStateHook(Store);
export const useTemplateLibraryActions = createActionsHook(Store);

// 'id' used to grab the template is from the index (not the template form)
// exported only for testing
export const getTemplateFormById = (state, id) => state.templates[id];
export const useTemplateForm = createStateHook(Store, {
  selector: getTemplateFormById
});